<template>
	<div data-test-id="modal-confirm-retry-redeem-ec-code">
		<CModal
			:show.sync="isShow"
			:close-on-backdrop="false"
			centered
		>
			<template #header-wrapper>
				<ModalHeaderWrapper
					title="ยืนยัน Redeem EC Code อีกครั้ง?"
					@onClose="close"
				/>
			</template>
			<template #default>
				<p class="mb-3">
					ระบบจะส่งคำขอ Redeem EC Code
					<span v-if="ecCode" class="ec-code">{{ ecCode }}</span>
					ไปที่ Apple ใหม่อีกครั้ง
				</p>
				<ul class="outcome-list mb-0 pl-3">
					<!-- <li>สำเร็จ &rarr; สถานะเปลี่ยนเป็น &ldquo;Redeem สำเร็จ&rdquo; และออเดอร์เดินต่อไปสถานะ Preparing</li>
					<li>ไม่สำเร็จ &rarr; สถานะคงเดิม กดซ้ำได้อีกไม่จำกัดครั้ง ไม่มีผลเสียกับออเดอร์</li> -->
					<li>ระบบจะบันทึกชื่อคุณและเวลาที่กดไว้ใน Order history</li>
				</ul>
			</template>
			<template #footer>
				<CButton
					color="tertiary"
					class="transparent mr-3"
					:disabled="isSubmitting"
					@click="close"
				>
					ยกเลิก
				</CButton>
				<CButton
					data-test-id="submit-button"
					color="primary"
					class="transparent"
					:disabled="isSubmitting"
					@click="handleSubmit"
				>
					{{ isSubmitting ? 'กำลัง Redeem...' : 'ยืนยัน Redeem' }}
				</CButton>
			</template>
		</CModal>
	</div>
</template>

<script>
import ModalHeaderWrapper from '@/components/ModalHeaderWrapper.vue';

export default {
	name: 'ModalConfirmRetryRedeemECCode',
	components: {
		ModalHeaderWrapper,
	},
	props: {
		ecCode: {
			type: String,
			default: null,
		},
		isSubmitting: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			isShow: false,
		};
	},
	methods: {
		open() {
			this.isShow = true;
		},
		close() {
			this.isShow = false;
		},
		handleSubmit() {
			this.$emit('onConfirm');
		},
	},
};
</script>

<style lang="scss" scoped>
	.ec-code {
		font-weight: $font-weight-semi-bold;
		color: $color-black-90;
	}

	.outcome-list {
		@include typo-body-2;

		color: $color-black-45;

		li + li {
			margin-top: rem(4);
		}
	}
</style>
